import { fetchClanWarsSummary, fetchUserStats } from '$lib/apis/clanWars';
import {
	clanWarsSummary,
	loadingClanWarsSummary,
	loadingUserStatsInClanWars,
	userStatsInClanWars
} from '$lib/clanWars/store';
import type { ClanWarsSummary, UserStatsInClanWars } from '$lib/types/clanWars';

export async function getClanWarsSummary() {
	try {
		loadingClanWarsSummary.set(true);

		const data = (await fetchClanWarsSummary()) as ClanWarsSummary;
		clanWarsSummary.set(data);
	} catch (e) {
		console.log(e);
	} finally {
		loadingClanWarsSummary.set(false);
	}
}

export async function getUserStatsInClanWars(scwAddress: string) {
	try {
		loadingUserStatsInClanWars.set(true);

		const data = (await fetchUserStats(scwAddress)) as UserStatsInClanWars;
		userStatsInClanWars.set(data);
	} catch (e) {
		console.log(e);
	} finally {
		loadingUserStatsInClanWars.set(false);
	}
}
